export default __webpack_public_path__ + "static/initiative-7302f199aa40291940860806df59d56d.webp";